import React, { useState } from 'react';
import { Button, ButtonGroup, Text } from '@chakra-ui/react';

import { Modal, SelectWithConfirm } from 'shared-components';

import { VisaStatus } from '../../../../store/student/core/types';
import { useTranslation } from "react-i18next";

export interface IProps {
  label: string;
  value: VisaStatus;
  visaStatuses: string[];
  onUpdate: (visaStatus: VisaStatus) => void;
  onClose: () => void;
}

const EditVisaStatus = (props: IProps) => {
    const { t } = useTranslation('dialogs');
  const { label, value, visaStatuses = [] } = props;

  const [visaStatus, setVisaStatus] = useState<VisaStatus>(value);

  const submit = () => {
    props.onUpdate(visaStatus);
    props.onClose();
  };

  const handleStatusChange = (evt: React.FormEvent<HTMLSelectElement>) => {
    let status = VisaStatus.NONE;
    switch (evt.currentTarget.value) {
      case 'CAS not received':
        status = VisaStatus.CAS_NOT_RECEIVED;
        break;
      case 'CAS received':
        status = VisaStatus.CAS_RECEIVED;
        break;
      case 'Visa applied':
        status = VisaStatus.VISA_APPLIED;
        break;
      case 'Awaiting visa response':
        status = VisaStatus.AWAITING_VISA_RESPONSE;
        break;
      case 'UKVI request more info':
        status = VisaStatus.UKVI_REQUEST_MORE_INFO;
        break;
      case 'Visa received':
        status = VisaStatus.VISA_RECEIVED;
        break;
      case 'Visa refusal':
        status = VisaStatus.VISA_REFUSAL;
        break;
      case 'Intends to defer':
        status = VisaStatus.INTENDS_TO_DEFER;
        break;
      case 'Intends to withdraw':
        status = VisaStatus.INTENDS_TO_WITHDRAW;
        break;
    }
    setVisaStatus(status);
  };

  const visaStatusOptions = visaStatuses.map(status => ({
    label: status,
    value: status,
  }));

  return (
    <Modal
      id="edit-visa-status"
      show={true}
      title={label}
      onClose={props.onClose}
      footer={
        <ButtonGroup size={'lg'} spacing={3}>
          <Button id="back-button" onClick={() => props.onClose()}>
            Back
          </Button>

          <Button id="submit-status-button" onClick={submit} isDisabled={value === visaStatus} variant={'solid'}>
            Update Status
          </Button>
        </ButtonGroup>
      }
    >
      <SelectWithConfirm
        id={'visaStatus'}
        label={t('dialogs:visaStatus')}
        options={visaStatusOptions}
        value={visaStatus}
        placeHolder={t('dialogs:select')}
        onChange={(evt: React.FormEvent<HTMLSelectElement>) => handleStatusChange(evt)}
      />

      <Text mb={0}>{t('dialogs:noteThisStatusIsSelfReportedByTh')}</Text>
    </Modal>
  );
};

export default EditVisaStatus;
